<template>
    <b-modal id="buyAccModal" centered title="Xác nhận mua tài khoản">
      <div class="modal-body">
        <div class="alert alert-danger" style="display:none"></div>
        <table class="table table-bordered">
          <th colspan="2" class="text-center">
            <span id="acc-info">Thông tin tài khoản #{{ this.account.id }}</span>
          </th>
          <tr>
            <td class="col-sm-6">Mã số:</td>
            <td class="col-sm-6">{{ this.account.id }}</td>
          </tr>
          <tr>
            <td class="col-sm-6">Số dư:</td>
            <td class="col-sm-6">{{ Helper.formatMoney(this.currentWallet['cash']) }}<sup>vnd</sup></td>
          </tr>
          <tr>
            <td class="col-sm-6">Giá tiền:</td>
            <td class="col-sm-6" id="acc-price">{{ Helper.formatMoney(this.account.price) }}<sup>vnd</sup></td>
          </tr>
          <tr>
            <td class="col-sm-6">Tổng tiền:</td>
            <td class="col-sm-6">{{ Helper.formatMoney(this.salePrice == 0 ? this.account.price : this.salePrice) }}<sup>vnd</sup></td>
          </tr>
        </table>
      </div>
      <div class="modal-header" style="display: block">
        <h5 class="modal-title">Mã giảm giá:</h5>
        <div class="input-group ">
          <input type="text" class="form-control" placeholder="Mã giảm giá" v-model="voucher">
          <button type="button" class="btn btn-sm btn-warning col-sm-4 padding-0" @click="handleBuyAccount(voucher, true)">SỬ
            DỤNG</button>
        </div>
        <label for="">Nhập mã giảm giá nếu có để nhận ưu đãi</label>
        <!-- <label v-if="this.account.price > this.currentWallet['cash']" class="text-danger" >
          Bạn không thể mua tài khoản này do tiền của bạn không đủ! Vui lòng nạp thêm.
        </label> -->
        <label id="message" :class="this.isSuccessMsg ? 'text-success' : 'text-danger'" >{{ this.message }}</label>
      </div>
      <template #modal-footer="{cancel }">
        <button type="button" class="btn btn-sm btn-secondary" @click="cancel()">Đóng</button>
        <button type="button" class="btn btn-sm btn-success" id="btn-submit-buy-acc" :disabled="btn_disabled" v-show="!showButtonAddFun"
                @click="handleBuyAccount(voucher, false)">Mua ngay</button>
        <button type="button" class="btn btn-sm btn-warning" id="btn-add-fun-momo"
                v-show="showButtonAddFun"
                v-b-modal:depositViaATM
                @click="closeModal()"
        >
          ATM-MOMO
        </button>
        <button type="button" class="btn btn-sm btn-warning" id="btn-submit-add-fun-card"
                v-show="showButtonAddFun"
                v-b-modal:depositViaPhoneCardModal
                @click="closeModal()"
        >
          THẺ CÀO
        </button>
      </template>
    </b-modal>
</template>

<script>
export default {
  props: {
    user: {
      Type: Object,
      default() {
        return {};
      }
    },
    currentWallet: {
      Type: Array,
      default() {
        return [];
      }
    },
    account: {
      Type: Object,
      default() {
        return {};
      }
    },
    website: {
      Type: Object,
      data() {
        return {}
      }
    }
  },
  data() {
    return {
      voucher: '',
      showButtonAddFun: false,
      salePrice: 0,
      message: '',
      isSuccessMsg: false,
      btn_disabled: false
    }
  },
  mounted() {
    this.showButtonAddFun = this.canBuyAcc();
  },
  watch: {
    account: function () {
      this.showButtonAddFun = this.canBuyAcc();
      this.resetDataModal();
    }
  },
  methods: {
    canBuyAcc() {
      return this.currentWallet['cash'] < this.account.price;
    },
    closeModal() {
      this.resetDataModal();
      this.$bvModal.hide('buyAccModal');
    },
    resetDataModal() {
      this.voucher = '';
      this.message = '';
      this.salePrice = this.account.price;
    },
    appendMessage(message, success = false) {
      this.message = message;
      this.isSuccessMsg = success;
    },
    async handleBuyAccount(voucher_code, is_check_voucher) {
      if (is_check_voucher && voucher_code === ''){
        this.appendMessage('Nhập voucher!');
        return;
      }
      this.btn_disabled = true
      try {
        const uri = this.route('fe_buy_account', {domain: this.website.domain});
        const response = await this.Request.post(uri, {id: this.account.id, voucher_code: voucher_code, is_check_voucher: is_check_voucher});
        if (response.data.status === false) {
          this.appendMessage(response.data.message);
          this.salePrice = this.account.price;
        } else {
          await this.$swal.fire({
              icon: 'success',
              title: 'Thành Công',
              html: response.data.message,
            }
          );
          if (is_check_voucher) {
            this.salePrice = response.data.new_price;
            this.appendMessage('Áp dụng voucher thành công!', true);
          } else {
            this.currentWallet['cash'] = this.currentWallet['cash'] - (this.salePrice == 0 ? this.account.price : this.salePrice);
            this.closeModal();
            window.location.href = this.route('lsmua', {domain: this.website.domain});
          }
        }
      } catch (e) {
        const errorMessages = this.Request.errors(e.response);
        await this.$swal({
          icon: 'error',
          title: 'Error',
          text: this._.isEmpty(errorMessages) ? e.response.data.error : errorMessages[0],
        });
      }
      this.btn_disabled = false
    }
  }
}
</script>

<style scoped>

</style>
